import {ResolutionNameConstants, ResolutionClassNameConstants, IMAGE_BASE_PATH} from './constants';
import * as CommonUtil from '../../common/util';
import { DEFAULT_DATE_FORMAT } from '../../common/constants';
import querystring from 'query-string';

export function prepareHashMetaData (props , state){
    return {
        workkardId : props.workkard.Id,
        activity:{
          selectedId:state.clickedActivityId,
          pagination: {
            skip: 0,
            take: props.activities.skip + props.activities.take
          }
        },
        middlePannel: {
          selectedTab: 'Log',
          pagination:{
            skip:0,
            take:10
          },
          filterApplied : [
            {
              type : 5,
              value : 4
            }
          ]
        }
      };
}

export function GetFileSizeRounded (fileSize) {
  let fs = +fileSize;
  if (!isNaN(fs)) {
      //when size is more than 1 MB
      if (fs >= 1048576) {
          fs = fs / 1048576;
          return Math.round(fs) + " MB";
      }
          //when size is more than 1 KB
      else if (fs >= 1024) {
          fs = fs / 1024;
          return Math.round(fs) + " KB";
      }

      //when size is less than  1 KB
      return Math.round(fs) + " bytes";
  }
  return "";
}

export function generateNewGuid(){
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8); return v.toString(16);
   })
}
export function getUniqueId(date,bRetPrev){
    let uPrev=null;
    if (bRetPrev)
      { return uPrev; }
      uPrev = new Date(date).getTime() + Math.random().toString().substring(2, 16);
      return uPrev;
}

export function getUnique(array) {
  let last, result = [];
  array.forEach(element => {
    if (element && !isNaN(element) && !result.includes(element.trim())) {
      result.push(element.trim());
    }
  });
  result.sort();
  return result;
}

export function getResolutionName(sResolution, bClassName, bExact=false){
  if (sResolution?.toLowerCase().indexOf('in progress') != -1) return (bClassName)? ResolutionClassNameConstants.inprogress : (bExact)? sResolution : ResolutionNameConstants.inprogress;
  switch (sResolution.toLowerCase()) {
      case 'inprogress':
        return (bClassName)? ResolutionClassNameConstants.inprogress : ResolutionNameConstants.inprogress;
      case 'closedmidterm':
      case 'closed midterm':
      case 'closed mid-term':
        return (bClassName)? ResolutionClassNameConstants.closedmidterm : ResolutionNameConstants.closedmidterm;
      case 'rejectedclosed':
      case 'rejected closed':
        return (bClassName)? ResolutionClassNameConstants.closedrejected : ResolutionNameConstants.closedrejected;
      case 'reassigned closed':
      case 'reassignedclosed':
        return (bClassName)? ResolutionClassNameConstants.reassignedclosed : ResolutionNameConstants.reassignedclosed;
      case 'reassigned':
        return (bClassName) ? ResolutionClassNameConstants.reassigned : ResolutionNameConstants.reassigned;
      case 'close':
      case 'closed':
        return (bClassName)? ResolutionClassNameConstants.close : ResolutionNameConstants.close;
      case 'reopened':
        return (bClassName)? ResolutionClassNameConstants.reopened : ResolutionNameConstants.reopened;
      case 'reopen':
        return (bClassName) ? ResolutionClassNameConstants.reopened : ResolutionNameConstants.reopened;
      case 'completed':
        return (bClassName)? ResolutionClassNameConstants.completed : ResolutionNameConstants.completed;
      case 'cancelled':
        return (bClassName)? ResolutionClassNameConstants.cancelled : ResolutionNameConstants.cancelled;
      case 'accepted':
        return (bClassName)? ResolutionClassNameConstants.accepted : ResolutionNameConstants.accepted;
      case 'rejected':
        return (bClassName)? ResolutionClassNameConstants.rejected : ResolutionNameConstants.rejected;
      case 'assigned':
        return (bClassName)? ResolutionClassNameConstants.assigned : ResolutionNameConstants.assigned;
      default:
          return sResolution;
  }
}

export function renderImage(fileName){
  return IMAGE_BASE_PATH+fileName;
}

/**
* create  a hash  url
*/
export function SeturlHash(combined,activityId,workkardId,history, hash = null,diaries=false, replace = false){
 //let encryptedHash = CommonUtil.jsonEncrypt(prepareHashMetaData(this.props,this.state));
  let searchString =querystring.parse(window.location.search, {parseBooleans: true, parseNumbers: true});
  let cId = workkardId ? workkardId : searchString.cId;
  let actId = activityId ? activityId : searchString.actId;
  let redirectPath = {
    pathname: '/getclmdetail'
  } 

  if (combined) {
    redirectPath.search = `?cId=${cId}&combined=${combined}`
    redirectPath.hash = hash ? hash : ''
  } else if(diaries)
  {
    redirectPath.search = `?tvw=${hash}`
    redirectPath.pathname='/tdo'
  }
  else {
      delete searchString.actId
      delete searchString.cId
      delete searchString.combined
      redirectPath.search = `?cId=${cId}`
      if(actId) {
        redirectPath.search += `&actId=${actId}`
      }
      const restSearch = querystring.stringify(searchString)
      if(restSearch) {
        redirectPath.search += `&${restSearch}`
      }
      redirectPath.hash = hash ? hash : window.location.hash;
  }
  if (replace) {
    history?.replace(redirectPath);
  } else { CommonUtil.redirectURL(history, redirectPath); }
}

export function fileIconBasedOnFileName(fileType){
  const type=fileType.toLowerCase();
  switch(type){
    case "pdf":
        return "uploadPdf"
    case "xml":
    case "other":
      return type
    case "esx":
      return "uploadEsx";
    
    case "accdb":
    case "css":
    case "db":
    case "dbf":
    case "docm":
    case "docx":
    case "dotx":
    case "dotm":
    case "dwg":
    case "dxf":
    case "gbr":
    case "ged":
    case "htm":
    case "html":
    case "ibooks":
    case "indd":
    case "key":
    case "keychain":
    case "log":
    case "mdb":
    case "pages":
    case "pdb":
    case "doc":
    case "odt":
    case "sdf":
    case "sql":
    case "tar":
    case "tax2012":
    case "tex":
    case "vcf":
    case "wpd":
    case "wps":
      return 'uploadWord';
      
    case "jpg":
    case "jpeg":
    case "bmp":
    case "gif":
    case "png":
    case "tff":
    case "tiff":
    case "tif":
    case "image":
    case "dds":
    case "psd":
    case "pspimage":
    case "tga":
    case "thm":
    case "yuv":
    case "webp":
      return 'Image';

    case "xls":
    case "xlsm":
    case "excel":
    case "xlsb":
    case "xlsx":
    case "xlt":
    case "xltm":
    case "xlw":
    case "xps":
    case "xsl":
    case "xlk":
    case "xlr":
    case "csv":
    case "xlm":
    case "ods":
      return 'uploadExcel';

    case "flv":
    case "mp4":
    case "aaf":
    case "3gp":
    case "avi":
    case "dat":
    case "m4v":
    case "mkv":
    case "mov":
    case "mpeg":
    case "mpg":
    case "mpe":
    case "swf":
    case "wmv":
    case "vob":
    case "ts":
    case "rmvb":
    case "video":
    case "asf":
    case "3g2":
    case "asx":
    case "rm":
    case "srt":
    case "webm":
        return 'video';

    case "text":
    case "txt":
    case "rtf":
        return "uploadTxt"

    case "ogg":
    case "amr":
    case "mp2":
    case "mp3":
    case "wma":
    case "aac":
    case "m4a":
    case "m4p":
    case "3gpp":
    case "wav":
    case "audio":
    case "aif":
    case "iff":
    case "m3u":
    case "mid":
    case "mpa":
    case "ra":
    case "flac":
        return 'uploadAudio';

    case "agt":
    case "asv":
    case "bdf":
    case "bina":
    case "boe":
    case "box":
    case "bri":
    case "cnm":
    case "dbx":
    case "eml":
    case "emlx":
    case "ezm":
    case "gmp":
    case "gwi":
    case "idb":
    case "ldi":
    case "ldif":
    case "mail":
    case "maildb":
    case "mailhost":
    case "mau":
    case "mbg":
    case "mbox":
    case "mbs":
    case "mbx":
    case "mht":
    case "mlm":
    case "mmdf":
    case "mozeml":
    case "msb":
    case "msf":
    case "nws":
    case "outlook97":
    case "p10":
    case "pbx":
    case "pm1":
    case "pm3":
    case "pmc":
    case "pmi":
    case "pmm":
    case "pmx":
    case "pop":
    case "pst":
    case "rcv":
    case "sbd":
    case "schd":
    case "smd":
    case "smp":
    case "tbb":
    case "tnf":
    case "vrge08note":
    case "wdseml":
    case "msg":
        return 'uploadMsg';     // A new file type case added to handle issue TS-1469
    case "zip":
    case "sitx":
    case "7z":
    case "rar":
    case "gz":
      return 'uploadZip';

    case "ppt":
    case "pptx":
    case "pps":
    case "pptm":
    case "sldm":
    case "ppsm":
    case "potm":
        return 'uploadPpt';
    default:
        return 'default';
  }
}

export function getDatePatternArray(date){
  if(date?.indexOf('-') > -1) {
      return date.split('-');
  } else if(date?.indexOf('/') > -1) {
      return date.split('/');
  }
}

export function getDateFormatIndex(){
  const patternArr = getDatePatternArray(DEFAULT_DATE_FORMAT.toLowerCase());
  const dateIndex = [0,1,2];
  const mIndex = patternArr.indexOf('m');
  const mmIndex = patternArr.indexOf('mm');
  const dIndex = patternArr.indexOf('d');
  const ddIndex = patternArr.indexOf('dd');
  let result = {};

  let index;
  if(mIndex > -1){
      result.month=mIndex
      index = dateIndex.indexOf(mIndex)
      dateIndex.splice(index,1);
  }
  else if(mmIndex > -1){
      result.month = mmIndex;
      index = dateIndex.indexOf(mmIndex)
      dateIndex.splice(index,1);
  }
  if(dIndex > -1){
      result.day = dIndex;
      index = dateIndex.indexOf(dIndex)
      dateIndex.splice(index,1);
  }
  else if(ddIndex > -1){
      result.day= ddIndex
      index = dateIndex.indexOf(ddIndex)
      dateIndex.splice(index,1);
  }
  result.year = dateIndex[0];

  return result;
}
 
export function getCustomerLastName (customFields) {
    var customerTag = "";
    customFields.map((data) => {
        if (data.FieldKey == 'customername_lastname_string')
            return customerTag = data.Value;
    })
    return customerTag;
}

export function dispatchCustomEvent(isIE, eventName, args = {}) {
  if (isIE) {
    const customEvent = document.createEvent('CustomEvent');
    customEvent.initCustomEvent(eventName, true, true, args);
    document.dispatchEvent(customEvent);
  } else {
    window.dispatchEvent(new CustomEvent(eventName, {
      detail: args
    }));
  }
}

export function base64ToArrayBuffer(base64) {
  var binary_string = window.atob(base64);
  var len = binary_string.length;
  var bytes = new Uint8Array(len);
  for (var i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
  }
  return bytes.buffer;
}